import React from "react";
import styles from "./SummaryHeader.module.scss";
import classNames from "classnames";

export const SummaryHeaderItem = ({Icon, value, label, unit, className, style, color}) => {
    return <div className={classNames(styles['summary-item'], className, {[styles['no-icon']]: !Icon})} style={style}>
        {Icon && <Icon/>}
        <div>
            <div className={classNames(styles['summary-value'], color && styles[color])}>{value}{unit && <span>{unit}</span>}</div>
            <div  className={styles['summary-label']}>{label}</div>
        </div>
    </div>
};

export const SummaryHeader = ({children, className, style}) => {
    return <div className={classNames(styles["base"], className)} style={style}>
        {children}
    </div>
}
